module.exports = __webpack_public_path__ + "img/banner_bg.55ccf8c2.jpg";